<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="ot-fade-in"></div>
<div class="modal-cookies">
    <div class="ck-header">
        <img
            class="logo__header"
            alt="logo-header"
            [src]="'images/logo-alamo.webp' | cdn"
        />
        <a class="cloose" (click)="closeModal()">
            <img
                class="close-menu-img"
                alt="close menu"
                [src]="'/images/close.svg' | cdn"
        /></a>
    </div>
    <div class="ck-content">
        <h4>{{ 'fe-cookies-modal_title-1' | translate }}</h4>
        <p>
            {{ 'fe-cookies-modal_description-1' | translate }}
        </p>
        <h4>{{ 'fe-cookies-modal_title-2' | translate }}</h4>
        <p>
            {{ 'fe-cookies-modal_description-2_1' | translate }}
        </p>
        <p>
            {{ 'fe-cookies-modal_description-2_2' | translate }}
        </p>
        <p>
            {{ 'fe-cookies-modal_description-2_3' | translate }}
        </p>
        <h4>{{ 'fe-cookies-modal_title-3' | translate }}</h4>
        <p>
            {{ 'fe-cookies-modal_description-3' | translate }}
        </p>

        <h4>{{ 'fe-cookies-modal_title-4' | translate }}</h4>

        <ng-container>
            <div ngbAccordion class="ck-options">
                <div
                    class="accordion-item rounded-0"
                    [collapsed]="ssr.isPlatformBrowser()"
                    ngbAccordionItem
                    #accItem="ngbAccordionItem"
                >
                    <div>
                        <div
                            ngbAccordionHeader
                            ngbAccordionToggle
                            class="header-options"
                        >
                            <h4 class="title">
                                {{
                                    'fe-cookies-modal_title-options-1'
                                        | translate
                                }}
                            </h4>
                            <div class="d-flex">
                                <p class="info-button">
                                    {{
                                        'fe-cookies-modal_description-option'
                                            | translate
                                    }}
                                </p>
                                <img
                                    class="icon ms-1 ms-sm-3"
                                    [src]="'images/chevron-alt-down.png' | cdn"
                                    alt="more info button"
                                    [ngClass]="{
                                        'rotate-icon': !accItem.collapsed
                                    }"
                                />
                            </div>
                        </div>
                        <div ngbAccordionCollapse class="content__info__hidden">
                            <div ngbAccordionBody class="px-0 py-0">
                                {{
                                    'fe-cookies-modal_description-option-info-1'
                                        | translate
                                }}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="accordion-item rounded-0"
                    [collapsed]="ssr.isPlatformBrowser()"
                    ngbAccordionItem
                    #accItem="ngbAccordionItem"
                >
                    <div>
                        <div ngbAccordionHeader class="header-options">
                            <h4 class="title" ngbAccordionToggle>
                                {{
                                    'fe-cookies-modal_title-options-2'
                                        | translate
                                }}
                            </h4>
                            <div class="d-flex">
                                <div>
                                    <input
                                        class="apple-switch"
                                        type="checkbox"
                                        [(ngModel)]="checkOption"
                                        [ngModelOptions]="{
                                            standalone: true
                                        }"
                                    />
                                </div>
                                <img
                                    class="icon ms-1 ms-sm-3"
                                    [src]="'images/chevron-alt-down.png' | cdn"
                                    alt="more info button"
                                    [ngClass]="{
                                        'rotate-icon': !accItem.collapsed
                                    }"
                                    ngbAccordionToggle
                                />
                            </div>
                        </div>
                        <div ngbAccordionCollapse class="content__info__hidden">
                            <div ngbAccordionBody class="px-0 py-0">
                                {{
                                    'fe-cookies-modal_description-option-info-2'
                                        | translate
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="ck-footer">
            <div>
                <fe-button
                    [style]="'link2btn'"
                    [btnClass]="'ck-confirm'"
                    (onClick)="closeModal()"
                >
                    {{ 'fe-cookies-modal_confirm-btn' | translate }}
                </fe-button>
            </div>
        </div>
    </div>
</div>
